/**
 * Product tags constants and configuration
 */

// Tag priorities (lower number = higher priority)
export const TAG_PRIORITIES = {
    promotional: 1,
    'van-bommel': 2,
    new: 3,
    bestseller: 4
}

// Category keywords for tag detection
export const CATEGORY_KEYWORDS = {
    new: ['new'],
    bestseller: ['bestseller'],
    'van-bommel': ['van-bommel', 'vanbommel', 'van bommel']
}

// Tag display configuration
export const TAG_CONFIG = {
    promotional: {
        color: 'error', // red
        text: null
    },
    'van-bommel': {
        color: 'orange',
        text: 'tags.vanBommel'
    },
    new: {
        color: 'orange',
        text: 'tags.new'
    },
    bestseller: {
        color: 'orange',
        text: 'tags.bestseller'
    }
}
